// extracted by mini-css-extract-plugin
export default {"url":"ContainerRegistry_url__m4u3r","icon":"ContainerRegistry_icon__PXdtf","copyBtn":"ContainerRegistry_copyBtn__dlzBD"};